module.exports = __webpack_public_path__ + "media/images/icons/outlined/medium-500ef1503643a1eef8b830adf8222373.svg";